import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Naam", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "E-mailadres", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Telefoonnummer", -1)
const _hoisted_4 = ["href"]

import { issueStore } from '@/stores/issue'

export default /*#__PURE__*/_defineComponent({
  __name: 'IssueShowContactDetailsCard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Contactpersoon",
    bordered: false
  }, {
    default: _withCtx(() => [
      (_unref(issueStore)().issue.contact_name)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 0,
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 9 }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                offset: 1,
                span: 14
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(issueStore)().issue.contact_name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(issueStore)().issue.contact_email)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 1,
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 9 }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                offset: 1,
                span: 14
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_unref(issueStore)().issue.contact_email), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(issueStore)().issue.contact_phone)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 2,
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 9 }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                offset: 1,
                span: 14
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: 'tel:' + _unref(issueStore)().issue.contact_phone
                  }, _toDisplayString(_unref(issueStore)().issue.contact_phone), 9, _hoisted_4)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})